/* eslint-disable react/button-has-type */
import * as React from 'react';

// AI-Generated Documentation - Please Read with Caution

type Props = {
  /**
   * Additional CSS classes to apply to the button
   * @default ''
   */
  className?: string;
  /**
   * Button style (appended to 'btn-' class)
   * @default 'default'
   */
  btnStyle?: string;
  /** Text or content to display in the button */
  text?: string | JSX.Element;
  /** Event handler called when the button is clicked */
  onClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
  /** Tooltip text shown on hover (uses HTML title attribute) */
  tooltip?: string;
  /** When true, disables the button */
  disabled?: boolean;
  /**
   * HTML button type
   * @default 'button'
   */
  type?: 'button' | 'submit' | 'reset';
};

/** A customizable button component that supports different styles and behaviors. */
class Button extends React.Component<Props> {
  static defaultProps = {
    btnStyle: 'default',
    type: 'button',
    className: '',
  };

  render() {
    const { className, btnStyle, onClick, tooltip, disabled, text, type } = this.props;

    const buttonClassName = `${className} btn btn-${btnStyle}`;

    return (
      <button type={type} className={buttonClassName} onClick={onClick} title={tooltip} disabled={disabled}>
        {text}
      </button>
    );
  }
}

export default Button;
